<template>
  <!-- 这个是项目查看页面 -->
  <div class="contain">
    <!-- 这里边是一个标题 -->
    <div class="title_box">
      <h4>项目详情</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回项目列表</el-button>
    </div>
    <!-- 这里是一个面板 -->
    <el-card class="box-card">
      <h6>项目名称</h6>
      <p>{{details.name}}</p>
      <h6>申办方</h6>
      <p>{{details.sponsor}}</p>
      <h6>联系人</h6>
      <p>{{details.contacts}}</p>
      <h6>联系方式</h6>
      <p>{{details.phone}}</p>
      <h6>邮箱</h6>
      <p>{{details.email}}</p>
      <h6>微信号</h6>
      <p>{{details.wechat}}</p>
      <h6>备注</h6>
      <p>{{details.remarks}}</p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'viewProject',
  data () {
    return {
      details: {}
    }
  },
  created () {
    this.getDetails(this.$route.query.id)
  },
  methods: {
    async getDetails (id) {
      const { data: data } = await this.$http.post('project/detail', {
        id
      })
      this.details = data.data
    },
    backProject () {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    flex: 1;
    // overflow-y: auto;
    h6 {
      color: #a7a7a7;
      font-size: 16px;
      margin-top: 40px;
      &:nth-child(1) {
        margin-top: 0px;
      }
    }
    p {
      font-size: 16px;
      color: #212529;
      margin-top: 20px;
    }
  }

  /deep/ .el-card {
    overflow: visible;
  }
}
</style>
